import { HTTP_API_V2 } from '../../http-common'

function fetchSetpointAction (metricKey) {
  const setMutation = metricKey === 't'
    ? 'setLoadedInobramxTemperatureSetpoints'
    : 'setLoadedInobramxHumiditySetpoints'

  return async function ({ commit }, payload) {
    commit('clearError')
    commit('setLoading', true)
    return new Promise((resolve, reject) => {
      HTTP_API_V2.get('inobramx/setpoint', {
        params: {
          mac: payload.mac || null,
          granularity: 'daily',
          metric: metricKey,
          initial_date: payload.initial_date || null,
          final_date: payload.final_date || null
        }
      })
        .then(result => {
          commit(setMutation, result.data)
          resolve(result.data)
        })
        .catch(err => {
          commit('setError', err)
          reject(err)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  }
}

export default {
  state: {
    loadedInobramxTemperatureSetpoints: null,
    loadedInobramxHumiditySetpoints: null
  },
  getters: {
    loadedInobramxTemperatureSetpoints (state) {
      return state.loadedInobramxTemperatureSetpoints
    },
    loadedInobramxHumiditySetpoints (state) {
      return state.loadedInobramxHumiditySetpoints
    }
  },
  mutations: {
    setLoadedInobramxTemperatureSetpoints (state, payload) {
      state.loadedInobramxTemperatureSetpoints = payload
    },
    setLoadedInobramxHumiditySetpoints (state, payload) {
      state.loadedInobramxHumiditySetpoints = payload
    },
    clearLoadedInobramxSetpoints (state) {
      state.loadedInobramxTemperatureSetpoints = null
      state.loadedInobramxHumiditySetpoints = null
    }
  },
  actions: {
    fetchInobramxTemperatureSetpoints: fetchSetpointAction('t'),
    fetchInobramxHumiditySetpoints: fetchSetpointAction('h'),
    clearLoadedInobramxSetpoints ({ commit }) {
      commit('clearLoadedInobramxSetpoints')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/inobramx_setpoint/index.js